import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'prime-dialog',
  standalone: true,
  imports: [
    DialogModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prime-dialog.component.html',
  styleUrl: './prime-dialog.component.scss'
})
export class PrimeDialogComponent {
  onCloseButton = output<void>();

  header = input<string>();
  headerRef = input(false);
  visible = input(false);
  modal = input(true);
  resizable = input(false);
  draggable = input(false);
  closeOnEscape = input(false);
  maxizable = input(false);
  closable = input(true);
  position = input<'left' | 'right' | 'top' | 'topleft' | 'topright' | 'bottom' | 'bottomleft' | 'bottomright' | 'center'>('center');

  breakpoints = input<any>();
  style = input<any>();

  classes = input<string>();


  handleCloseButton() {
    this.onCloseButton.emit();
  }
}
